import { render, staticRenderFns } from "./AllCom.vue?vue&type=template&id=5ab44321&"
import script from "./AllCom.vue?vue&type=script&lang=ts&"
export * from "./AllCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports